import React from 'react';
import './Filters.css';

const Filters = ({ selectedCategories, setSelectedCategories, allSelected, setAllSelected, filtersVisible, setFiltersVisible }) => {
  const handleCategoryChange = (category) => {
    const newSelectedCategories = {
      ...selectedCategories,
      [category]: !selectedCategories[category]
    };
    setSelectedCategories(newSelectedCategories);
    setAllSelected(Object.values(newSelectedCategories).every(value => value));
  };

  const handleSelectAllChange = () => {
    const newValue = !allSelected;
    const newSelectedCategories = Object.keys(selectedCategories).reduce((acc, category) => {
      acc[category] = newValue;
      return acc;
    }, {});
    setSelectedCategories(newSelectedCategories);
    setAllSelected(newValue);
  };

  const categoryNames = {
    castle: 'Château',
    church: 'Église',
    house: 'Maison / Domaine',
    building: 'Autre',
    ruin: 'Ruines'
  };

  const categoryMap = {
    ruin: 'ruins',
    castle: 'castle',
    church: 'church',
    house: 'house',
    building: 'building'
  };

  return (
    <div className="filters-button" onMouseEnter={() => setFiltersVisible(true)}>
      <span>Filtrer</span>
      <span className="arrow-down">▼</span>
      <div 
        className={`filter-dropdown ${filtersVisible ? 'visible' : ''}`} 
        onMouseLeave={() => setFiltersVisible(false)}
      >
        <div className="filter-option" onClick={handleSelectAllChange}>
          <div className="custom-checkbox">
            <input
              type="checkbox"
              checked={allSelected}
              onChange={handleSelectAllChange}
            />
            <span className="checkmark"></span>
          </div>
          <span>Sélectionner Tout</span>
        </div>
        {Object.keys(selectedCategories).map(category => (
          <div key={category} className="filter-option" onClick={() => handleCategoryChange(category)}>
            <div className="custom-checkbox">
              <input
                type="checkbox"
                checked={selectedCategories[category]}
                onChange={() => handleCategoryChange(category)}
              />
              <span className="checkmark"></span>
            </div>
            <div className="filter-icon">
              <img src={`/icons/${categoryMap[category]}.svg`} alt={categoryNames[category]} />
            </div>
            <span>{categoryNames[category]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Filters;